module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader",
    class: [{
      'loader--small': _vm.isSmall
    }, {
      'loader--modal': _vm.isLoaderModal
    }, {
      'loader--extra-small': _vm.isExtraSmall
    }],
    style: (_vm.styleObj),
    attrs: {
      "role": "status",
      "aria-live": "polite",
      "aria-label": _vm.$t('vue2.a11y.loading')
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cf919a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Loader.vue
// module id = 1789
// module chunks = 1